import type {
    FC
} from "react";
import type ICommandItemProps from "./type";

const CommandItem: FC<ICommandItemProps> = () => {
    return null;
};
export default Object.assign(CommandItem, {
    commandPart: "item"
});
